import _ from 'lodash';
import { MIN_PRICE } from './constants';
import {
  SortingMethod,
  VALID_SORTING_METHODS,
  ValidSortingMethods,
} from '@common/types';

export const hasActiveBudgetFilter = (selectedPricing: any) => {
  if (!_.isNil(selectedPricing)) {
    if (selectedPricing.min !== MIN_PRICE) {
      return true;
    } else if (
      !_.isEmpty(selectedPricing.max) ||
      !_.isNaN(selectedPricing.max)
    ) {
      return true;
    }
    return false;
  }
  return false;
};

export const hasActiveLocationFilter = (selectedLocation: any) => {
  if (!_.isNil(selectedLocation)) {
    return true;
  }
  return false;
};

export const activeFilterCountExcludingBudget = ({
  selectedServices,
  selectedLanguages,
  selectedLocation,
}: any) => {
  let num = 0;
  if (!_.isNil(selectedServices)) {
    num += _.size(selectedServices);
  }
  if (!_.isNil(selectedLanguages)) {
    num += _.size(selectedLanguages);
  }

  if (hasActiveLocationFilter(selectedLocation)) {
    num += 1;
  }

  return num;
};

export const activeFilterCount = ({
  selectedServices,
  selectedLanguages,
  selectedPricing,
  selectedLocation,
}: any) => {
  let num = activeFilterCountExcludingBudget({
    selectedServices,
    selectedLanguages,
    selectedLocation,
  });

  if (hasActiveBudgetFilter(selectedPricing)) {
    num += 1;
  }
  return num;
};

export const getSortFilterOptions = (
  t: Function,
  isSortByBestSellerSpecEnabled: boolean,
) => {
  const excludeMethods: ValidSortingMethods[] = [];

  if (!isSortByBestSellerSpecEnabled) {
    excludeMethods.push(ValidSortingMethods.PURCHASES);
  }

  return VALID_SORTING_METHODS.filter(
    (sortingMethod: SortingMethod) =>
      !excludeMethods.includes(sortingMethod as ValidSortingMethods),
  ).map((sortingMethod: SortingMethod) => ({
    id: sortingMethod,
    value: t(`marketplace.templates-page.${sortingMethod}`),
  }));
};
